import _ from 'lodash';

// Supermove
import {gql} from '@supermove/graphql';
import {AccountCalendarModel} from '@supermove/models';
import {withFragment} from '@supermove/utils';

export interface AccountCalendarFormFields {
  accountGrantId?: string;
  nylasCalendarId?: string;
  organizationId: string;
  accountCalendarId?: number;
}

const edit = withFragment<AccountCalendarModel, AccountCalendarFormFields>(
  (accountCalendar) => {
    return {
      accountGrantId: accountCalendar.accountGrantId,
      nylasCalendarId: accountCalendar.nylasCalendarId,
      organizationId: accountCalendar.organizationId,
      accountCalendarId: _.toNumber(accountCalendar.id),
    };
  },
  gql`
    fragment AccountCalendarForm_edit on AccountCalendar {
      id
      nylasCalendarId
      accountGrantId
      organizationId
    }
  `,
);

const _new = ({organizationId}: {organizationId: string}): AccountCalendarFormFields => {
  return {
    organizationId: organizationId.toString(),
    accountGrantId: undefined,
    nylasCalendarId: undefined,
  };
};

const toMutation = (form: AccountCalendarFormFields): AccountCalendarFormFields => {
  return {
    accountGrantId: form.accountGrantId,
    nylasCalendarId: form.nylasCalendarId,
    organizationId: form.organizationId,
    accountCalendarId: form.accountCalendarId,
  };
};

const AccountCalendarForm = {
  edit,
  toMutation,
  new: _new,
};

export default AccountCalendarForm;
